import React from 'react';
import { Box, LinkProps } from 'pounceV2';
import { Link as RRLink } from 'react-router-dom';

export type LinkButtonWrapperPropsV3 = Pick<LinkProps, 'external' | 'disabled' | 'target'> &
  React.PropsWithChildren & {
    /** The path to navigate to - can be a string or react-router location object */
    to?: string | { pathname?: string; search?: string; hash?: string; state?: unknown };
  };

const LinkButtonWrapperV3: React.FC<LinkButtonWrapperPropsV3> = ({
  disabled,
  external,
  to,
  target,
  children,
}) => {
  let linkProps: LinkProps & {
    to?: string | { pathname?: string; search?: string; hash?: string; state?: unknown };
  };
  if (disabled) {
    linkProps = { as: 'span' as React.ElementType };
  } else if (!external) {
    // When using RRLink, to can be a string or location object
    linkProps = { to: to as any, as: RRLink };
  } else {
    linkProps = {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: to as string,
      as: 'a' as React.ElementType,
    };
  }

  if (target) {
    linkProps.target = target;
  }

  return (
    <Box
      {...linkProps}
      sx={{
        '& > span': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        },
      }}
    >
      {children}
    </Box>
  );
};
export default LinkButtonWrapperV3;
